import { render, staticRenderFns } from "./ViewXSelector.vue?vue&type=template&id=ffb684ac&scoped=true&"
import script from "./ViewXSelector.vue?vue&type=script&lang=js&"
export * from "./ViewXSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb684ac",
  null
  
)

export default component.exports